export default "__VITE_ASSET__C13$ExH1__"